@if (data?.length) {
  @for (info of data; track info) {
    <div class="info-content">
      <div class="heading">
        <label>{{ info.propertyName }}</label>
      </div>
      <div class="value">
        <p class="info">{{ info.propertyValue }}</p>
        <p class="info-sub">{{ info.subPropertyValue }}</p>
        <div class="line"></div>
      </div>
    </div>
  }
}
@if (!data?.length) {
  <div class="no-record">
    <p>No Records</p>
  </div>
}